/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visual_GalleryInputs */

const en_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visual Gallery`)
};

const es_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galería visual`)
};

const fr_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie visuelle`)
};

const de_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visuelle Galerie`)
};

const ja_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビジュアルギャラリー`)
};

const zh_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视觉图库`)
};

const ar_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعرض المرئي`)
};

const id_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri Visual`)
};

const it_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galleria Visiva`)
};

const ru_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Визуальная галерея`)
};

const pt_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria Visual`)
};

const ko_visual_gallery = /** @type {(inputs: Visual_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비주얼 갤러리`)
};

/**
* | output |
* | --- |
* | "Visual Gallery" |
*
* @param {Visual_GalleryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const visual_gallery = /** @type {((inputs?: Visual_GalleryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visual_GalleryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_visual_gallery(inputs)
	if (locale === "es") return es_visual_gallery(inputs)
	if (locale === "fr") return fr_visual_gallery(inputs)
	if (locale === "de") return de_visual_gallery(inputs)
	if (locale === "ja") return ja_visual_gallery(inputs)
	if (locale === "zh") return zh_visual_gallery(inputs)
	if (locale === "ar") return ar_visual_gallery(inputs)
	if (locale === "id") return id_visual_gallery(inputs)
	if (locale === "it") return it_visual_gallery(inputs)
	if (locale === "ru") return ru_visual_gallery(inputs)
	if (locale === "pt") return pt_visual_gallery(inputs)
	return ko_visual_gallery(inputs)
});